import { handleRequest } from "../utilities/requestHandler";

export const createNewUser = (req_body) =>
    handleRequest("post","/users/create",req_body);